<template>
  <div class="detail">
    <div class="center">
      <div class="orderDetail">
        <p>订单信息</p>
        <div class="ordDetail">
          <div class="head">
            <span>商品信息</span>
            <span>单价</span>
            <span>数量</span>
            <span>小计</span>
            <span>实付</span>
          </div>
          <ul v-for="(order, index) in goodsList" :key="index">
            <li v-for="(orderitem, i) in goodsList[index].orderItemDtoList" :key="i">
              <div>
                <div class="lileft" :style="'background-image: url(' + orderitem.itemImage + ')'"></div>
                <div class="liright" v-if="orderitem.itemType == 0">
                  <p>
                    <span
                      class="prizeTab"
                      v-if="
                        orderitem.activityDetailMaps &&
                          orderitem.activityDetailMaps[0].activityType === 3 &&
                          orderitem.itemType === 0
                      "
                    ></span
                    >{{ orderitem.itemName }}
                  </p>
                  <!--抽奖标签-->
                  <p v-if="orderitem.attributeMap">
                    颜色：{{ getSelectedAttrNameByAttributeMap(orderitem.attributeMap) }}
                  </p>
                </div>
                <div class="liright" v-else>
                  <p>{{ orderitem.itemName }}&nbsp;{{ getSelectedAttrNameByAttributeMap(orderitem.attributeMap) }}</p>
                  <!-- <p>官方指导价:{{Number(orderitem.originFee)|currency('￥',2)}}</p> -->
                  <p>经销商：{{ getDealNameByExtraMap(orderitem.extraMap) }}</p>
                </div>
              </div>
              <div>{{ orderitem.skuOriginPrice | currency('￥', 2) }}</div>
              <div>x{{ orderitem.quantity }}</div>
              <div>{{ orderitem.originFee | currency('￥', 2) }}</div>
              <div>{{ orderitem.fee | currency('￥', 2) }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="amountDetails">
        <p>商品明细</p>
        <ul class="amDetails">
          <li>
            <span>商品件数:</span><span>{{ goodsNumber }}件</span>
          </li>
          <li>
            <span>商品总积分:</span><span style="color: #C6001F;">￥{{ compoutedPrice.tempFee }}</span>
          </li>
          <li>
            <span>活动优惠:</span><span>￥{{ compoutedPrice.discount }}</span>
          </li>
          <!-- <li><span>优惠卷折扣:</span><span>￥0</span></li> -->
          <li>
            <span>运费:</span><span>￥{{ compoutedPrice.shipFee }}</span>
          </li>
          <li>
            <span>应付总额:</span><span style="color: #C6001F;">￥{{ compoutedPrice.totalFee }}</span>
          </li>
        </ul>
      </div>
      <div class="button">
        <el-button type="primary" :loading="orderPush" class="submit" @click="orderConfirm">提交订单</el-button>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
// import { Dialog, Button, Cascader } from 'element-ui'
import { Button } from 'element-ui'
import orderApi from '@/api/order.js'
export default {
  name: 'zero-order-confirm',
  data() {
    return {
      orderId: this.$route.params.orderId,
      orderPush: false,
      isGoods: false, // 商品   整车   搭配购   默认整车0
      addressMsg: {}, // 收货地址信息
      defaultAddress: {
        addressType: '',
        id: '',
        receiverName: '',
        mobile: '',
        zipCode: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        details: '',
        isDefault: ''
      },
      invoiceChoose: false, // 发票选择按钮
      invoiceMsg: {
        contentText: '', // 选择内容
        headFill: '' // 发票抬头
      },
      allCoupon: 0,
      useCoupon: 0,

      goodsList: [], // 商品列表
      compoutedPrice: {
        totalFee: 0, // 总费用
        discount: 0, // 总折扣
        shipFee: 0, // 总运费
        tempFee: 0 // 商品合计
      },
      goodsNumber: 0
    }
  },
  computed: {},
  components: {
    // elDialog: Dialog,
    elButton: Button
    // elCascader: Cascader
  },
  methods: {
    getOrderList() {
      // 获取订单详情
      orderApi.getOrderDetail({ orderId: this.orderId }).then((res) => {
        if (res.status === 200) {
          this.goodsList = res.data.orderContracts
          res.data.orderContracts.forEach((val) => {
            this.goodsNumber += val.orderItemDtoList.length
          })
          this.compoutedPrice.eventDiscount = res.data.order.extraMap.discount
            ? res.data.order.extraMap.discount.activity
            : 0
          this.compoutedPrice.couponDiscount = res.data.order.extraMap.discount
            ? res.data.order.extraMap.discount.coupon
            : 0
          this.compoutedPrice.shipFee = res.data.order.shipFee
          this.compoutedPrice.totalFee = res.data.order.fee
          this.compoutedPrice.tempFee = res.data.order.originFee
        }
      })
    },
    getSelectedAttrNameByAttributeMap(attributeMap) {
      if (!attributeMap || !(attributeMap.reduce instanceof Function)) {
        return ''
      }
      return attributeMap.reduce((total, next, i, attr) => {
        return (
          total +
          Object.keys(next.attributeMap).reduce((ctotal, cnext, ci, cattr) => {
            return ctotal + (i === 0 && ci === 0 ? '' : '/') + next.attributeMap[cnext]
          }, '')
        )
      }, '')
    },
    getDealNameByExtraMap(extraMap) {
      return extraMap && extraMap.dealer && extraMap.dealer.dealerName ? extraMap.dealer.dealerName : ''
    },
    orderConfirm() {
      // 订单确认
      const param = {
        orderId: this.orderId,
        invoiceDto: {
          invoiceType: this.invoiceMsg.invoiceType,
          invoiceTitle: this.invoiceChoose ? this.invoiceMsg.headFill : '',
          invoiceContent: this.invoiceChoose ? this.invoiceMsg.contentText : ''
        },
        vin: this.Vinvalue,
        userAddressId: this.defaultAddress.id
      }
      this.orderPush = true
      orderApi.orderConfirm(param).then(
        (res) => {
          if (res && res.data && res.status === 200) {
            this.$api
              .getPayUrl({
                orderId: this.$route.params.orderId,
                agencyCode: '07',
                channelCode: '0',
                returnUrl: ''
              })
              .then((res) => {
                if (res.status === 200) {
                  res.data.freeOrder === 'true'
                    ? this.$router.push('/order/pay-success/' + this.orderId)
                    : this.$feedback('订单异常')
                } else {
                  this.$feedback(res.message)
                }
                this.orderPush = false
              })
              .catch(() => {
                this.orderPush = false
                this.$feedback('订单异常')
              })
          } else {
            this.orderPush = false
            this.$feedback(res.message)
          }
        },
        () => {
          this.orderPush = false
        }
      )
    }
  },
  created() {
    this.getOrderList()
  }
}
</script>

<style scoped lang="scss">
.detail {
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
}
.center {
  width: 1360px;
  margin: 0 auto;
  padding: 19px 0 51px;
  line-height: 38px;
  font-size: 16px;
  color: #333;
  input {
    font-size: 16px;
  }
  .orderDetail {
    margin-top: 20px;
    > p {
      font-weight: 600;
      font-size: 18px;
      line-height: 55px;
      color: rgba(51, 51, 51, 1);
    }
    .ordDetail {
      width: 100%;
      line-height: 49px;
      overflow: hidden;
      border: 1px solid rgba(208, 208, 208, 1);
      .head {
        padding: 0 30px;
        background: #000;
        height: 49px;
        color: #fff;
        span {
          text-align: right;
          float: left;
          width: 12%;
        }
        span:first-of-type {
          text-align: left;
          width: 50%;
        }
      }
      ul {
        background: #fff;
        padding: 0 30px;
        li {
          border-bottom: 1px dashed #b4b4b4;
          height: 187px;
          &:last-child {
            border: none;
          }
          > div {
            text-align: right;
            float: left;
            width: 12%;
            font-size: 18px;
            line-height: 187px;
          }
          > div:first-of-type {
            display: flex;
            width: 50%;
            text-align: left;
            margin: 22px 0;
            .lileft {
              width: 202px;
              height: 143px;
              background-position: center;
              background-repeat: no-repeat;
              background-size: contain;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .liright {
              flex: 1;
              padding: 0 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              p {
                line-height: 32px;
                font-size: 16px;
              }
              p:first-of-type {
                font-weight: 600;
                font-size: 18px;
                line-height: 35px;
                margin-top: 15px;
                white-space: initial;
              }
            }
            .prizeTab {
              display: block;
              width: 42px;
              height: 25px;
              background: url('../../assets/images/activity/lottery/prize.png') no-repeat;
              background-size: 100% 100%;
              float: left;
              margin-top: 5px;
              margin-right: 6px;
            }
          }
          > div:last-of-type {
            color: #c6001f;
          }
        }
      }
    }
    .coupon {
      background: #fbfcff;
      overflow: hidden;
      padding-right: 30px;
      .num {
        cursor: pointer;
        span {
          color: #c6001f;
        }
      }
      div {
        float: right;
        height: 70px;
        line-height: 70px;
        padding-left: 26px;
      }
      .cou {
        background: url('../../assets/images/order-confirm/default.png') no-repeat left center;
        cursor: pointer;
      }
      .cou-checked {
        background-image: url('../../assets/images/order-confirm/use-coupon.png');
      }
    }
  }
  .amountDetails {
    margin-top: 20px;
    padding-bottom: 40px;
    > p {
      font-weight: 600;
      font-size: 18px;
      line-height: 55px;
    }
    .amDetails {
      width: 100%;
      overflow: hidden;
      border-top: 1px solid rgba(208, 208, 208, 1);
      > li {
        width: 100%;
        overflow: hidden;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-top: 7px;
        span:first-child {
          float: left;
        }
        span:last-child {
          float: right;
        }
      }
      > li:last-child {
        font-size: 23px;
        font-weight: 500;
        color: #333333;
        margin-top: 32px;
      }
    }
  }
  .button {
    width: 100%;
    overflow: hidden;
    .submit {
      float: right;
      border: 0;
      width: 220px;
      height: 56px;
      font-size: 20px;
      background: #c6001f;
      color: #fff;
      border-radius: 0;
    }
  }
}
</style>
